import React, { useEffect } from 'react';
import { useGame } from '../context/GameContext.jsx';
import Card from './Card.jsx'; // Reutilizando o componente Card

const OutcomeScreen = () => {
  const { translations, lang, currentCards, gameStatus, setSessionId } = useGame();

  useEffect(() => {
    // Ao exibir a tela de desfecho, remover o sessionId do localStorage
    localStorage.removeItem('sessionId');
    localStorage.removeItem('cardLanguage'); // Também limpa o cardLanguage
    setSessionId(null); // Limpa o sessionId no contexto
  }, [setSessionId]);

  // Encontra a carta de desfecho na lista de cartas atuais
  // A carta de desfecho terá Type: 'story' e Category: 'victory' ou 'defeat'
  const isVictoryStatus = gameStatus === 'victory';
  const outcomeCard = currentCards.find(card => 
    card.Type && card.Type.toLowerCase() === 'story' &&
    card.Category && (
      (isVictoryStatus && card.Category.toLowerCase() === 'victory') ||
      (!isVictoryStatus && card.Category.toLowerCase() === 'defeat')
    )
  );

  // Se não houver uma carta de desfecho específica, cria uma mockada
  const displayCard = outcomeCard || {
    Code: isVictoryStatus ? 'V' : 'D',
    Type: 'story',
    Category: isVictoryStatus ? 'victory' : 'defeat',
    Title: isVictoryStatus ? translations[lang]?.victory_title : translations[lang]?.game_over_title,
    Subtitle: isVictoryStatus ? translations[lang]?.victory_message : translations[lang]?.game_over_message,
    FieldValue: isVictoryStatus ? translations[lang]?.victory_details_placeholder : translations[lang]?.no_game_over_card_found,
    Image: isVictoryStatus ? 'victory.png' : 'defeat.png' // Assumindo que essas imagens existem em /public/assets/cards/
  };

  const handleBackToStart = () => {
    // Redireciona para a URL atual sem o hash
    window.location.href = window.location.origin + window.location.pathname + window.location.search;
  };

  return (
    <div className="outcome-screen-content d-flex flex-column align-items-center">
      <Card card={displayCard} isMissionCard={false} /> {/* isMissionCard false para não exibir mod/goals */}
      <button 
        className="btn btn-primary mt-4" 
        onClick={handleBackToStart}
      >
        {translations[lang]?.new_game_button}
      </button>
    </div>
  );
};

export default OutcomeScreen;
